module.exports = __webpack_public_path__ + "img/sestar.ec1d4e34.svg";